import type { NotifyPort } from '@/features/messages/domain/notify'
import type { OrgTeam, OrgTeamPort } from '../domain/member'

type UpdateTeamInput = Pick<OrgTeam, 'name'>

const updateTeam = async (
	port: OrgTeamPort,
	id: string,
	input: UpdateTeamInput,
	notify: NotifyPort,
): Promise<OrgTeam | null> => {
	try {
		const team = await port.updateTeam(id, input)
		notify.success('hr.teamUpdated')
		return team
	} catch {
		notify.error('hr.teamUpdateFailed')
		return null
	}
}

export { updateTeam }
export type { UpdateTeamInput }
